import React, { Component, useState } from 'react';
import { container } from 'tsyringe';
import { WebRTCsdkService } from '../../services/webrtcsdk-service'

import "./FakeRemoteVideo.scss";

export default class FakeRemoteVideo extends Component {


  private webRTCsdkService = container.resolve(WebRTCsdkService);

  private remoteVideoElement = new Array(25);
  private localVideoElement = React.createRef<HTMLVideoElement>();
  private remoteContentElement = React.createRef<HTMLVideoElement>();
  private localContentElement = React.createRef<HTMLVideoElement>();

  constructor(props) {
    super(props);
    for (let index = 0; index < 25; index++) {
      this.remoteVideoElement[index] = React.createRef<HTMLVideoElement>();
    }
  }

  componentDidMount() {
    for (let index = 0; index < 25; index++) {
      this.webRTCsdkService.attachRemoteVideo(this.remoteVideoElement[index].current, index)
    }
    this.webRTCsdkService.attachLocalVideo(this.localVideoElement.current)
    this.webRTCsdkService.attachRemoteContent(this.remoteContentElement.current)
    // this.webRTCsdkService.attachLocalContent(this.localContentElement.current)
  }


  render() {

    const remoteIndexes = new Array(25);
    for (let i = 0; i < 25; i++) {
      remoteIndexes.push(('0' + i).slice(-2));
    }

    return (
      <div className="fakevideo-container">
        <video className="localVideo" ref={this.localVideoElement} id="localvideo"></video>
        <video className="contentVideo" ref={this.remoteContentElement} id="remotecontentvideo"></video>
        <video className="contentVideo" ref={this.localContentElement} id="localcontentvideo"></video>
        <br />
        {remoteIndexes.map(index =>
          <video key={"remoteVideo" + index} className={"remoteVideo video" + index} ref={this.remoteVideoElement[parseInt(index, 10)]} id={"remotevideo" + index}></video>
        )}
      </div>
    )
  }
}
